module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_selfie_old-d8c2c8931a8c3a8de6080bd39ee70d44.jpg";